import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { useFeatureFlags } from "@/contexts/FeatureFlagsContext";
import { Header } from "./Header";
import { useLayout } from "@/contexts/LayoutContext";
import { cn } from "@/lib/utils";

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const { showOpportunityAssessment, showReadinessAssessment } = useFeatureFlags();
  const { isPaddingDisabled, isTransparent } = useLayout();

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Header />

      {/* Main content with added top padding */}
      <main className={cn("flex-1", !isPaddingDisabled, !isTransparent && "bg-gray-50")}>
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t bg-white font-inter">
        <div className="max-w-[1920px] mx-auto px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 2xl:px-32 py-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="space-y-4">
              <h3 className="font-semibold">PermitLab</h3>
              <p className="text-sm text-gray-500">
                <Link to={ROUTES.HOME} className="hover:text-primary">AI-Powered Permitting Toolkit</Link>
              </p>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li><Link to={ROUTES.PERMIT_BENCHMARKING.ROOT} className="hover:text-primary">Permit Benchmarking</Link></li>
                {showOpportunityAssessment ? (
                  <li><Link to={ROUTES.OPPORTUNITY_ASSESSMENT.ROOT} className="hover:text-primary">Opportunity Assessment</Link></li>
                ) : (
                  <li><button disabled className="text-gray-400 cursor-not-allowed">Opportunity Assessment</button></li>
                )}
                {showReadinessAssessment && (
                  <li><Link to={ROUTES.READINESS_ASSESSMENT.ROOT} className="hover:text-primary">Readiness Assessment</Link></li>
                )}
                {/* <li><button disabled className="text-gray-400 cursor-not-allowed">ROI Calculator</button></li>
                <li><button disabled className="text-gray-400 cursor-not-allowed">City Profile</button></li> */}
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li>
                  <a href="https://www.govstream.ai/#about-us" className="hover:text-primary">
                    About Us
                  </a>
                </li>                
                <li>
                  <a href="https://www.govstream.ai/#request-a-demo" className="hover:text-primary">
                    Get Support
                  </a>
                </li>               
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Legal</h4>
              <ul className="space-y-2 text-sm text-gray-500">
                <li><a href="https://www.govstream.ai/" className="hover:text-primary">Terms of Service</a></li>
                <li><a href="https://www.govstream.ai/" className="hover:text-primary">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t text-center text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} AI Permitting Toolkit. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout;